<ng-container *ngIf="viewModel$ | async as viewModel">
  <div class="travel-time" aria-live="polite" aria-atomic="true">
    <i
      [attr.aria-label]="
        viewModel.distancesLoading ? 'Loading travel time' : 'Travel time'
      "
      role="img"
      [class]="
        viewModel.distancesLoading ? 'pi pi-spin pi-spinner' : 'pi pi-truck'
      "
    ></i>
    <span *ngIf="viewModel.distancesLoading"> Calculating... </span>
    <span *ngIf="!viewModel.distancesLoading && !viewModel.locationsMissing">
      {{ label }}: {{ viewModel.estimatedTime | secondsToTimeUnit }} ({{
        viewModel.distance | distance: viewModel.distanceUnits
      }})
    </span>
    <span *ngIf="!viewModel.distancesLoading && viewModel.locationsMissing">
      {{ label }}: N/A
    </span>
  </div>
</ng-container>
